export default {
    data: () => {
        return {
            loading: false
        }
    },
    watch: {
        loading: function(val) {
            if (val) {
                $('.loading-wrapper').addClass('active');
            } else {
                $('.loading-wrapper').removeClass('active');
            }
        },
    },
    methods: {
        memberApi: async function(route, request) {
            if (!this.loading) {
                this.loading = true
                try {
                    const token = document.head.querySelector('meta[name="session-token"]');
                    if (token) {
                        window.axios.defaults.headers.common["Authorization"] = 'Bearer ' + token.content;
                    }

                    if (request.lang == null) request.lang = locale;

                    const { data } = await axios.post(route, request);

                    let code = data.code.toString()
                    this.loading = false
                    return {
                        code: code,
                        status: code.slice(code.length - 1) === "0",
                        data: data.data,
                        message: data.message
                    }
                } catch (error) {
                    this.loading = false
                    return {
                        status: false,
                        message: data.message
                    }
                }
            }
        },
        restrictMobile(val) {
            return val.replace(/[^0-9]/g, '').substr(0, 8);
        },
        validateMobile(val) {
            const regex = /[4,5,6,7,8,9]{1}[0-9]{7}/
            return val && regex.test(val)
        },
        restrictYuu(val) {
            return val.replace(/[^0-9]/g, '');
        },
        validateYuu(val) {
            const regex = /^[0-9]/
            return val && regex.test(val)
        },
        restrictOctopus(val) {
            return val.replace(/[^0-9]/g, '');
        },
        validateEmail(val) {
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(val).toLowerCase());
        },
        validateOctopus(val) {
            const regex = /^[0-9]/
            return val && regex.test(val)
        },
    },
};